import React from 'react';
import PropTypes from 'prop-types';
import SimpleDetails from './simple-details';
import InfoLinkDetails from './info-link-details';
import AreaDetails from './area-details';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DetailsMap = {
  simple: SimpleDetails,
  area: AreaDetails,
  infoLink: InfoLinkDetails
};
var KeyDetailsItem = props => {
  var ItemComponent = DetailsMap[props.type];
  return ___EmotionJSX(ItemComponent, props);
};
KeyDetailsItem.propTypes = {
  type: PropTypes.string,
  approximate: PropTypes.bool,
  className: PropTypes.string
};
KeyDetailsItem.defaultProps = {
  type: 'simple',
  approximate: false,
  className: null
};
export default KeyDetailsItem;